/**
 * The "Contact sales" destination for a plan absent from `v1/subscriptions/plans`
 * (issue #603 AC-1/AC-3, contracts table) — the same URL the account menu's
 * existing "Contact Sales" item already opens
 * (`src/app/core/header/header.component.html`).
 */
export const CONTACT_SALES_URL = "https://vengreso.com/request-appointment";

/** The tracking event fired for every "Contact sales" click (issue #603 contracts table). */
export const CONTACT_SALES_TRACKING_EVENT = "clicked_contact_sales";
